"use strict";
exports.__esModule = true;
exports.INFO_COLLECTION_MODAL_CONTENT = void 0;
exports.INFO_COLLECTION_MODAL_CONTENT = {
    TITLE: 'Why does Flex have to collect certain personal info?',
    BODY: 'Federal law requires all financial institutions to obtain, verify, and record information that identifies each person who opens an account.\n\nThis information is collected to help the government fight the funding of terrorism and money laundering activities.',
    CTA: 'Close'
};
